import type { PyodideInterface } from "pyodide";

import { cacheSingleton } from "./utils/cache";

async function initPyodide(indexURL: string = "https://cdn.jsdelivr.net/pyodide/v0.25.0/full/", env?: Record<string, string>, packages: string[] = ["micropip", "typing-extensions"]) {
  const { loadPyodide } = await import("pyodide");
  return await loadPyodide({ indexURL, env: { ...env }, packages });
}

async function initPy() {
  const [py, { AsyncClient }, version, { default: initCode }] = await Promise.all([
    initPyodide(),
    import("./translate"),
    import("openai/version"),
    import("./init.py?raw"),
  ]);

  py.registerJsModule("openai", { AsyncClient, Client: () => null, version, __all__: null });
  py.registerJsModule("httpx", { AsyncClient: () => null, Client: () => null });

  await py.runPythonAsync(initCode);

  return py;
}

export const getPy: () => Promise<PyodideInterface> = cacheSingleton(initPy);

export async function initConsole() {
  const [py, { default: initConsoleCode }] = await Promise.all([getPy(), import("./console.py?raw")]);
  await py.runPythonAsync(initConsoleCode);
}
